<template>
	<div :class="['input-wrapper', { error: hasError }]">
		<label :for="name">
			<div class="heading-5">
				{{ `${label} ` }}
				<span>{{ ` ${required ? ' *' : ''}` }}</span>
			</div>
		</label>
		<div class="input-container">
			<input
				ref="timeInput"
				type="time"
				:class="size"
				:value="localValue"
				:min="formattedMinHour"
				:max="formattedMaxHour"
				:required="required"
				@input="updateValue"
				@click="expandTimePicker"
			/>
		</div>
		<div class="heading-5" style="color: #6694e3;">
			Timezone: {{ Intl.DateTimeFormat().resolvedOptions().timeZone }} (GMT{{
				gmt
			}})
		</div>
		<div v-show="hasError" class="error-msg">{{ error }}</div>
	</div>
</template>
<script>
export default {
	props: {
		label: {
			type: String,
			default: ''
		},
		required: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		value: {
			type: String,
			default: ''
		},
		size: {
			type: String,
			default: 'large',
			validator: value => {
				return ['large', 'mid', 'small'].indexOf(value) !== -1;
			}
		},
		minHour: {
			type: String,
			default: null
		},
		maxHour: {
			type: String,
			default: null
		},
		name: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			error: null,
			localValue: this.value
		};
	},
	computed: {
		hasError() {
			return !!this.error;
		},
		formattedMinHour() {
			return this.minHour ? this.minHour : undefined;
		},
		formattedMaxHour() {
			return this.maxHour ? this.maxHour : undefined;
		},
		gmt() {
			const dt = new Date();
			return (
				(-dt.getTimezoneOffset() < 0 ? '-' : '+') +
				Math.abs(dt.getTimezoneOffset() / 60)
			);
		}
	},
	watch: {
		value(newValue) {
			this.localValue = newValue;
		}
	},
	methods: {
		updateValue() {
			this.error = null;
			let refValue = this.$refs.timeInput.value;
			this.$emit('input', refValue);
		},
		expandTimePicker() {
			this.$refs.timeInput.showPicker();
		}
	}
};
</script>
<style lang="scss" scoped>
.input-container {
	display: flex;
	flex-direction: row-reverse;
	align-items: center;
}
label {
	.heading-5 {
		color: $font-dark;
		margin-bottom: 4px;
		span {
			color: $requiredFieldAsterisk;
		}
	}
}
input {
	background-color: $input-bgcolor;
	border: 1px solid $container-border;
	border-radius: 4px;
	outline: 0;
	color: $input-color;
	font-family: 'RobotoRegular';
	font-size: 15px;
	line-height: 23px;
	letter-spacing: 0.5px;
	padding-right: 5px;

	@media (min-width: $breakpoint-mid) {
		font-size: 18px;
		line-height: 27px;
	}

	&:not(:disabled) {
		&:focus {
			border-color: $hover-state;
		}
	}

	&:disabled {
		background-color: $disabled-state;
		border: 1px solid $disabled-state;
		&:hover {
			cursor: not-allowed;
		}
	}

	&.large {
		height: 48px;
		width: 100%;
		text-indent: 5px;
	}

	&.mid {
		height: 48px;
		width: 240px;
		text-indent: 5px;
	}

	&.small {
		height: 32px;
		width: 84px;
		text-align: center;
	}
}

input[type='time']::-webkit-calendar-picker-indicator {
	filter: brightness(0) saturate(100%) invert(16%) sepia(60%) saturate(5284%)
		hue-rotate(212deg) brightness(94%) contrast(108%);
}
</style>
